Apt.fn.extend('property', {
	/**
	 * Transform thumbnail images
	 *
	 * @param {Array} images
	 * @param {String} prefix
	 * @param {Number} [load=6]
	 * @returns {Array}
	 */
	transformThumbs(images, prefix, load = 6) {
		images = images.map((image, i) => {
			image.path = prefix + '/large/' + image.key + '.jpg';
			image.small = image.path.replace('/large/', '/small/');

			image.position = i + 1;

			if (load && ((! i && images.length > load) || i > load)) {
				image.lazy = true;
			}

			return image;
		});

		images.push(images.shift());

		return images;
	}
}, {
	/**
	 * Initialize a media gallery
	 */
	initImages() {
		this.images = Apt.fn.gallery()
			.init({
				app: $.app.media,
				id: $.context('id'),
				bind: true,
				delegate: '$images',
				large: true,
				preload: Apt.panel.opened(),
				data: {
					hash: this.context.hash,
					images: $.context('media.images', [])
				}
			});
	},

	/**
	 * Initialize thumbnails
	 */
	initThumbnails() {
		const $thumbs = $$('propertyThumbs');

		if (! $thumbs.length) {
			return;
		}

		const scope = this;

		let $parent = $thumbs.parent();

		scope.lazyThumbs = Apt.fn.lazy()
			.init($('img[data-src]', $thumbs), {
				context: $parent,
				margin: 200
			});

		$.events.on('$thumbnail', {
			click: (e, el) => {
				scope.images.move(
					Number(el.dataset.position)
				);

				scope.tabs.select($$('propertyTabs').children()[0]);
			},
			mouseover: (e, el) => {
				scope.images.preload(
					Number(el.dataset.position)
				);
			}
		}, {
			namespace: 'property',
			delegate: $thumbs
		});

		LS.util.idle(() => {
			const $button = $$('propertyScroll');

			$button.on('mousedown', () => {
				$parent.scrollTop(320, true);
			}, {
				namespace: 'property',
				once: true
			});

			$parent.on('scroll', () => {
				$button.hide();
			}, {
				namespace: 'property',
				once: true
			});
		});
	}
});